// extracted by mini-css-extract-plugin
export default {"TabsWrapper":"tabs_TabsWrapper__bbpjL","TabItem":"tabs_TabItem__FlCAJ","isActive":"tabs_isActive__PnKiS","compact":"tabs_compact__888n+"};